export const specialCharRemove = (value: string) => {
  return value.replace(/[^a-zA-Z0-9 ]/g, '');
}

export const sanitizeAddressComplement = (value: string, maxLength = 15): string =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9 ]/g, '')
    .substring(0, maxLength);

export const isValidString = (input: string): boolean => {
  const regex = /^[A-Za-zÀ-ÖØ-ÿ0-9'.\- ]+$/;
  return regex.test(input);
}
